module.exports = __webpack_public_path__ + "img/caution.a425fe34.png";